import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Toast from "../components/Toast";
import { io } from "socket.io-client";
import PopupAlert from "../components/PopupAlert";

const FluffyTouchLeadComponent = ({ role, dataAccessDays }) => {
  const link = "https://api.shop.fluffytouch.in";
  // const link = "http://localhost:8001";
  const [page, setPage] = useState(0);

  const [data, setData] = useState([]);
  const [bookingId, setBookingId] = useState(null);
  const [editBooking, setEditBooking] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const [showCopyToast, setShowCopyToast] = useState(false);
  const [deleteBooking, setDeleteBooking] = useState(null);
  const [bookingData, setBookingData] = useState({});
  const [newBookings, setNewBookings] = useState([]);

  const socketRef = useRef(null);
  const audioRefNew = useRef(new Audio("/sounds/notification1.mp3"));
  const audioRefUpdate = useRef(new Audio("/sounds/notification.mp3"));

  const fetchData = useCallback(async () => {
    try {
      const response = await fetch(`${link}/all-bookings`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "GET",
      });

      const respData = await response.json();
      if (response.ok) {
        setData(respData.data.reverse());
      } else {
        alert(response.message);
      }
    } catch (error) {
      alert("Server Error.");
    }
  }, [link]);

  // Play audio safely
  const playSound = (audioRef) => {
    if (!audioRef.current) return;
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch((err) => {
      console.error("Playback error:", err);
    });
  };

  useEffect(() => {
    socketRef.current = io(link);
    socketRef.current.on("booking-book", (formData) => {
      setData((e) => [formData, ...e]);
      setNewBookings((e) => [formData, ...e]);
      playSound(audioRefNew);
      if (Notification.permission === "granted") {
        new Notification("Fluffy Touch New Booking", {
          body: `${formData.name ? `Name: ${formData.name}\n` : ""}Number: ${
            formData.phone
          }\nLocation: ${formData.address}`,
        });
      }
    });

    socketRef.current.on("booking-delete", () => {
      playSound(audioRefUpdate);
      fetchData();
      setShowToast(true);
      setEditBooking(null);
    });

    socketRef.current.on("booking-update", () => {
      playSound(audioRefUpdate);
      fetchData();
      setShowToast(true);
      setEditBooking(null);
    });

    fetchData();
    return () => {
      if (socketRef.current) {
        socketRef.current.off("form-book");
        socketRef.current.off("form-update");
        socketRef.current.off("form-delete");
        socketRef.current.disconnect();
      }
    };
  }, [fetchData, link]);

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  // Input handler for editing booking
  const handleInput = (e) => {
    setBookingData({
      ...bookingData,
      [e.target.name]: e.target.value,
    });
  };
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  // Update booking handler
  const handleUpdate = async () => {
    try {
      const response = await fetch(`${link}/update-booking/${bookingId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bookingData),
      });

      if (response.ok) {
        setShowToast(true);
        setEditBooking(false);
        fetchData();
      } else {
        alert("Error updating booking");
      }
    } catch (error) {
      alert("Server error");
    }
  };

  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  // Delete booking handler
  const handleDelete = async () => {
    try {
      const response = await fetch(`${link}/delete-booking/${bookingId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MzkyNzA4NDF9.hjZDULeRQ-ClnJn4wPHUaGI4l1LAoftdxMOA6TJt_VE",
        },
      });

      if (response.ok) {
        setShowToast(true);
        setEditBooking(false);
        setDeleteBooking(false);
        fetchData();
      } else {
        const data = await response.json();
        alert(data.message);
      }
    } catch (error) {
      alert("Server error");
    }
  };

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const copyLead = async (e) => {
    const text = `${e.pet ? `Pet : ${e.pet}` : ""}${
      e.name ? `\nName : ${e.name}` : ""
    }${e.phone ? `\nPhone : ${e.phone}` : ""}${
      e.breed ? `\nBreed : ${e.breed}` : ""
    }${e.service ? `\nService : ${e.service}` : ""}${
      e.addOns ? `\nAddOns Date : ${e.addOns}` : ""
    }${e.serviceDate ? `\nService Date : ${e.serviceDate}` : ""}${
      e.serviceTime ? `\nService Time : ${e.serviceTime}` : ""
    }${e.address ? `\nAddress : ${e.address}` : ""}`;

    try {
      await navigator.clipboard.writeText(text);
      setShowCopyToast(true);
    } catch (err) {
      alert("Failed to copy!");
    }
  };

  const whatsappLeadText = (e) => {
    const text = `${e.pet ? `Pet : ${e.pet}` : ""}${
      e.name ? `%0AName : ${e.name}` : ""
    }${e.phone ? `%0APhone : ${e.phone}` : ""}${
      e.breed ? `%0ABreed : ${e.breed}` : ""
    }${e.service ? `%0AService : ${e.service}` : ""}${
      e.addOns ? `%0AAddOns Date : ${e.addOns}` : ""
    }${e.serviceDate ? `%0AService Date : ${e.serviceDate}` : ""}${
      e.serviceTime ? `%0AService Time : ${e.serviceTime}` : ""
    }${e.address ? `%0AAddress : ${e.address}` : ""}`;

    return text;
  };

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const shareText = (e) => {
    const text = `${e.pet ? `Pet : ${e.pet}` : ""}${
      e.name ? `\nName : ${e.name}` : ""
    }${e.phone ? `\nPhone : ${e.phone}` : ""}${
      e.breed ? `\nBreed : ${e.breed}` : ""
    }${e.service ? `\nService : ${e.service}` : ""}${
      e.addOns ? `\nAddOns Date : ${e.addOns}` : ""
    }${e.serviceDate ? `\nService Date : ${e.serviceDate}` : ""}${
      e.serviceTime ? `\nService Time : ${e.serviceTime}` : ""
    }${e.address ? `\nAddress : ${e.address}` : ""}`;

    navigator.share
      ? navigator.share({ text: text })
      : alert("Share API not supported");
  };

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const filterData = React.useMemo(() => {
    if (role === "admin") return data;

    if (role === "user") {
      const today = new Date();
      const startDate = new Date(today);
      startDate.setDate(today.getDate() - dataAccessDays);
      return data.filter(
        (e) =>
          new Date(e.date).toISOString().split("T")[0] >
          startDate.toISOString().split("T")[0]
      );
    }

    // logout()
    return [];
  }, [data]);

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const totalItems = filterData.length;
  const startIndex = page * 50;
  const endIndex = Math.min(startIndex + 50, totalItems);
  const pageData = filterData.slice(startIndex, endIndex);

  // Pagination handlers
  const handleNext = () => {
    if (endIndex < totalItems) setPage((p) => p + 1);
  };
  const handlePrev = () => {
    if (page > 0) setPage((p) => p - 1);
  };

  return (
    <>
      {deleteBooking ? (
        <div className="dboard-log-out-alert-n">
          <PopupAlert
            heading="You want to delete booking. Are you sure ?"
            icon="fa-solid fa-trash"
            open={setDeleteBooking}
            action={handleDelete}
          />
        </div>
      ) : (
        ""
      )}

      {showToast ? (
        <Toast heading="Data Updated Sucessfully" open={setShowToast} />
      ) : (
        ""
      )}

      {showCopyToast ? (
        <Toast heading="Booking Copied Successfully" open={setShowCopyToast} />
      ) : (
        ""
      )}

      {newBookings.length > 0 ? (
        <div className="goc-dashbord-new-leads">
          <div className="goc-dashbord-new-leads-main">
            <div className="goc-dashbord-new-leads-head">
              <div>{newBookings.length} New Booking </div>
              <span onClick={() => setNewBookings([])}>clear</span>
            </div>

            {newBookings.length > 0 ? (
              newBookings.map((e) => (
                <div className="goc-dashbord-new-leads-list">
                  <div>
                    <div>{e.phone}</div>
                    <div>{e.name && e.name}</div>
                  </div>
                  <div>
                    <div> {new Date(e.date).toDateString()} </div>
                    <div> {new Date(e.date).toLocaleTimeString()} </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="goc-dashbord-new-leads-list">
                <b>No New Bookings</b>
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="repair-buddy-dashboard">
        <div className="goc-dashbord-leads-list-cotainer">
          <div className="goc-dashbord-leads-list-cotainer-header">
            <b>All Bookings</b>
            <div className="goc-dashbord-leads-list-cotainer-header-filter">
              {/* <div className="goc-dashbord-leads-list-cotainer-header-filter-buttons">
                      {page > 0 && (
                      <i onClick={handlePrev} className="fa-solid fa-angle-left"></i>
                    )}
                    <div>
                      {startIndex + 1}–{endIndex} of {totalItems}
                    </div>
                    {endIndex < totalItems && (
                      <i onClick={handleNext} className="fa-solid fa-angle-right"></i>
                    )}
                    </div> */}
            </div>
          </div>

          <div className="goc-dashbord-leads-list-inner-cotainer">
            <div className="goc-dashbord-leads-list-inner-header">
              <div>Details</div>
              <div>Booking Time</div>
              <div>Address</div>
              <div>Prefer Time</div>
              <div>Service & Pet</div>
              <div>Edit</div>
            </div>

            {/* sm-list  Header::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}
            {/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::  */}

            <div className="wraper-goc-dashbord-leads-booking-main-small-header">
              <div className="wraper-goc-dashbord-leads-booking-small-header">
                <div>Details</div>
                <div>Date Time</div>
              </div>
            </div>

            {pageData &&
              pageData.map((e, i) => (
                <>
                  <div className="goc-dashbord-leads-booking-list">
                    <div
                      className="goc-dashbord-leads-booking-list-data"
                      onClick={() => {
                        setBookingId(bookingId === e._id ? null : e._id);
                        setEditBooking(null);
                      }}
                    >
                      <div className="goc-leads-booking-list-col">
                        {e.name ? <div>{e.name}</div> : ""}
                        <div>{e.phone}</div>
                      </div>
                      <div className="goc-leads-booking-list-col">
                        <div> {new Date(e.date).toDateString()} </div>
                        <div> {new Date(e.date).toLocaleTimeString()} </div>
                      </div>
                      <div className="goc-leads-booking-list-col">
                        <div>{e.address ? e.address : "-"}</div>
                      </div>
                      <div className="goc-leads-booking-list-col">
                        <div>
                          {" "}
                          {e.serviceDate
                            ? new Date(e.serviceDate).toDateString()
                            : "---"}{" "}
                        </div>
                        <div> {e.serviceTime} </div>
                      </div>
                      <div className="goc-leads-booking-list-col">
                        <div>{e.service ? e.service : "--"}</div>
                        <div>
                          {e.pet}
                          {e.breed ? " - " + e.breed : ""}
                        </div>
                      </div>

                      <div className="goc-leads-booking-list-col"></div>
                    </div>

                    <div className="goc-leads-booking-list-col">
                      <div className="goc-dashbord-share-leads-btn">
                        <Link
                          target="_blank"
                          to={`https://web.whatsapp.com/send?text=${whatsappLeadText(
                            e
                          )}`}
                        >
                          <i class="fa-brands fa-whatsapp"></i>
                        </Link>
                        <i
                          class="fa-solid fa-copy"
                          onClick={() => copyLead(e)}
                        ></i>
                        <i
                          onClick={() => shareText(e)}
                          class="fa-solid fa-share"
                        ></i>
                      </div>
                    </div>

                    {bookingId === e._id ? (
                      <div className="goc-dashbord-lead-booking-full-details">
                        <div className="goc-dashbord-lead-booking-full-details-head">
                          <div className="goc-dashbord-lead-booking-full-details-heading">
                            Full Details :
                          </div>
                          <div className="goc-dashbord-lead-booking-full-details-options">
                            {editBooking ? (
                              <>
                                <span onClick={handleUpdate}>
                                  <i className="fa-solid fa-check-circle"></i>{" "}
                                  save
                                </span>

                                <span onClick={() => setEditBooking(null)}>
                                  <i className="fa-solid fa-xmark-circle"></i>{" "}
                                  cancle
                                </span>
                              </>
                            ) : (
                              <>
                                <span
                                  onClick={() => {
                                    setEditBooking(true);
                                    setBookingData(e);
                                  }}
                                >
                                  <i className="fa-solid fa-pen"></i> edit
                                </span>
                                {role === "admin" ? (
                                  <span onClick={() => setDeleteBooking(true)}>
                                    <i className="fa-solid fa-trash"></i> delete
                                  </span>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        <Link target="_blank" to={e.path}>
                          {e.path}
                        </Link>

                        {editBooking ? (
                          <div className="goc-dashbord-lead-booking-more-details">
                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Pet :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.pet}
                                name="pet"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Name :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.name}
                                name="name"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>phone :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.phone}
                                name="phone"
                                type="number"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Breed :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.breed}
                                name="breed"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Service :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.service}
                                name="service"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Add Ons :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.addOns}
                                name="addOns"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Service Date :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.serviceDate}
                                name="serviceDate"
                                type="date"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Service Time :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.serviceTime}
                                name="serviceTime"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Location :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.address}
                                name="address"
                                type="text"
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="goc-dashbord-lead-booking-more-details">
                            {e.pet ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Pet :</div>
                                <span>{e.pet}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.name ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Name :</div>
                                <span>{e.name}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.phone ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Phone :</div>
                                <span>{e.phone}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.breed ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Breed :</div>
                                <span>{e.breed}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.service ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Service :</div>
                                <span>{e.service}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.addOns ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>AddOns :</div>
                                <span>{e.addOns}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.serviceDate ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Service Date :</div>
                                <span>{e.serviceDate}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.serviceTime ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Service Time :</div>
                                <span>{e.serviceTime}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.address ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Address :</div>
                                <span>{e.address}</span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ))}

            {/* sm-list :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}
            {/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::  */}

            {pageData &&
              pageData.map((e, i) => (
                <div className="goc-dashbord-leads-booking-small-list">
                  <div className="goc-dashbord-leads-booking-small-inner-list">
                    <div className="sm-ds-list-number-postion">
                      <Link to={`tel:${e.phone}`}>{e.phone}</Link>
                    </div>
                    <div
                      onClick={() => {
                        setBookingId(bookingId === e._id ? null : e._id);
                        setEditBooking(null);
                      }}
                    >
                      <div className="wraper-goc-dashbord-leads-booking-small-inner-list">
                        <div>
                          <div className="goc-leads-booking-list-col   sm-goc-leads-booking-list-col">
                            <div> &nbsp; </div>
                            {e.name ? <div>{e.name}</div> : ""}
                          </div>
                        </div>
                        <div>
                          <div>
                            <div>{new Date(e.date).toDateString()}</div>
                            <div>{new Date(e.date).toLocaleTimeString()}</div>
                          </div>
                        </div>
                      </div>
                      <div className="goc-dashbod-lead-sm-booking-address-list">
                        {e.address ? <div>{e.address}</div> : ""}
                      </div>
                    </div>

                    {bookingId === e._id ? (
                      <div className="goc-dashbord-lead-booking-full-details">
                        <div className="goc-dashbord-lead-booking-full-details-head">
                          <div className="goc-dashbord-lead-booking-full-details-heading">
                            Full Details :
                          </div>
                          <div className="goc-dashbord-lead-booking-full-details-options">
                            {editBooking ? (
                              <>
                                <span onClick={handleUpdate}>
                                  <i className="fa-solid fa-check-circle"></i>{" "}
                                  save
                                </span>

                                <span onClick={() => setEditBooking(null)}>
                                  <i className="fa-solid fa-xmark-circle"></i>{" "}
                                  cancle
                                </span>
                              </>
                            ) : (
                              <>
                                <span
                                  onClick={() => {
                                    setEditBooking(true);
                                    setBookingData(e);
                                  }}
                                >
                                  <i className="fa-solid fa-pen"></i> edit
                                </span>
                                {role === "admin" ? (
                                  <span onClick={() => setDeleteBooking(true)}>
                                    <i className="fa-solid fa-trash"></i> delete
                                  </span>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        <Link target="_blank" to={e.path}>
                          {e.path}
                        </Link>

                        {editBooking ? (
                          <div className="goc-dashbord-lead-booking-more-details">
                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Pet :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.pet}
                                name="pet"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Name :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.name}
                                name="name"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>phone :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.phone}
                                name="phone"
                                type="number"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Breed :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.breed}
                                name="breed"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Service :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.service}
                                name="service"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Add Ons :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.addOns}
                                name="addOns"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Service Date :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.serviceDate}
                                name="serviceDate"
                                type="date"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Service Time :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.serviceTime}
                                name="serviceTime"
                                type="text"
                              />
                            </div>

                            <div className="goc-dashbord-lead-booking-more-details-list">
                              <div>Location :</div>
                              <input
                                onChange={handleInput}
                                value={bookingData.address}
                                name="address"
                                type="text"
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="goc-dashbord-lead-booking-more-details">
                            {e.pet ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Pet :</div>
                                <span>{e.pet}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.name ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Name :</div>
                                <span>{e.name}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.phone ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Phone :</div>
                                <span>{e.phone}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.breed ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Breed :</div>
                                <span>{e.breed}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.service ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Service :</div>
                                <span>{e.service}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.addOns ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>AddOns :</div>
                                <span>{e.addOns}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.serviceDate ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Service Date :</div>
                                <span>{e.serviceDate}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.serviceTime ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Service Time :</div>
                                <span>{e.serviceTime}</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {e.address ? (
                              <div className="goc-dashbord-lead-booking-more-details-list">
                                <div>Address :</div>
                                <span>{e.address}</span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="goc-dashbord-sm-share-leads-btn">
                    <Link
                      target="_blank"
                      to={`https://wa.me/?text=${whatsappLeadText(e)}`}
                    >
                      <i class="fa-brands fa-whatsapp"></i>
                    </Link>
                    <i class="fa-solid fa-copy" onClick={() => copyLead(e)}></i>
                    <i
                      onClick={() => shareText(e)}
                      class="fa-solid fa-share"
                    ></i>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FluffyTouchLeadComponent;
